export default {
  kanban_cards: [],
  crm_steps: [],
  lid: {},
  products: {
    results: [],
  },

  one_crm_info: [],
  dashboard: {},
  lead_exchange: [],
  steps_history: [],
}
